// extracted by mini-css-extract-plugin
export var br = "FlyoverUpsell2-module__br___fwoNy";
export var button = "FlyoverUpsell2-module__button___qMT8u";
export var close = "FlyoverUpsell2-module__close___okV8v";
export var container = "FlyoverUpsell2-module__container___bxjY8";
export var content = "FlyoverUpsell2-module__content___cauWX";
export var fine = "FlyoverUpsell2-module__fine___oay_n";
export var footer = "FlyoverUpsell2-module__footer___pzgXa";
export var header = "FlyoverUpsell2-module__header___jMeJY";
export var img = "FlyoverUpsell2-module__img___g7FbF";
export var interior = "FlyoverUpsell2-module__interior___yAkDm";